export enum OnboardingSetupGuideStep {
  CreateRegister = 1,
  ConnectIntegration = 2,
  AddAssets = 3,
  MapGlAccounts = 4,
  AddUsers = 5,
  Completed = 6,
}
